import React,{useState} from 'react'
import {Link} from 'react-router-dom'
import Header from '../../components/Primary/Header'

import ProductCard from '../../components/Primary/ProductCard'
import store from '../../assets/store.png'
import Footer from '../../components/Primary/Footer'
import { CartState } from "../../context/Context";
import {IoIosArrowForward} from 'react-icons/io'
import Pagination from '../../components/Primary/Pagination'
const AllProducts = () => {
  const [sort, setSort] = useState('ByPopularity');
  const[showFilter, setShowFilter] = useState(false);

  const {
    state: { products,cart },
   
  } = CartState();
  const findQty = id => {
    const item = cart.find(item => item.id === id);
    if(item){
      return item.qty
    }
    return null
  }
  return (

    <div className="bg-tradr-light font-poppins h-full w-full 2xl:container 2xl:mx-auto ">
        <Header />
        <div className="md:px-8 md:py-4  ">
        {/* WELOCOME CARD */}

        <div className="flex bg-blue mt-0 md:mt-14 space-x-4 rounded-lg px-4 py-8  ">
          {/* Left welcome */}
            <div className="flex flex-col items-start w-full lg:w-4/12 ">
                <h1 className=" font-bold block text-large text-white break-words w-full" 
                >
                
                Welcome to 
                <br/>
      Crowncollections Store
      </h1>
      <p className="text-sm font-light mb-4 text-gray-light">
      Satisfying your cravings
      </p>
      <Link to="/all-products" className="btn bg-tradr-green text-white font-normal py-2 px-4  uppercase mb-4 ">

       View All Products 
      </Link>

          </div>
          {/* Right welcome */}
          <div className=" hidden md:flex  justify-end items-center w-full lg:w-8/12  ">
         <div className="relative w-72">
         <img src={store} alt="store" className="w-6/6 h-80 rounded-lg cursor-pointer  absolute -top-40 right-10  object-cover  " 
          />
           
         </div>
          </div>
          </div>
        {/* END OF  WELOCOME CARD */}
        {/* Product action */}
        <div className="flex  items-center justify-between mt-2 md:mt-20 px-2">
          <div
          >
             <h1 className="font-poppins font-bold text-large" >
     Our Products
     </h1>
     <div className="underline" />
          </div>
          <div className="flex flex-col relative">
          
            <button className="font-poppins font-medium  text-base mb-2 bg-light-blue px-4 py-2 hover:bg-tradr-green hover:text-white flex justify-between align-center space-x-2 mt-2" onClick={() => setShowFilter(!showFilter)} >
           <p> {sort} </p>  <IoIosArrowForward className="mt-1" fontSize={20} />
            </button>
            {showFilter && (
            <div className="bg-white rounded-lg shadow-lg absolute top-12 right-0 mt-2 z-10 w-48">
            <div className="flex flex-col items-center justify-center px-4 py-2">
            <p className="font-poppins font-medium text-base mb-2  cursor-pointer hover:bg-gray-light w-full p-2"
            onClick={()=> {setSort('ByPopularity')
            setShowFilter(false)
          }}
            
            >ByPopularity</p>
            <p className="font-poppins font-medium text-base mb-2 cursor-pointer hover:bg-gray-light w-full p-2"
            onClick={()=> {setSort('ByRating')
            setShowFilter(false)
          }}
            
            >ByRating</p>
            <p className="font-poppins font-medium text-base mb-2 cursor-pointer hover:bg-gray-light w-full p-2"
            onClick={()=> {setSort('ByNewest')
            setShowFilter(false)
          }}
            
            >ByNewest</p>
            <p className="font-poppins font-medium text-base mb-2 cursor-pointer hover:bg-gray-light w-full p-2"
            onClick={()=> {setSort('ByOldest')
            setShowFilter(false)
          }}
            
            >ByOldest</p>

          </div>
          </div>
          )}
          </div>
          </div>
          {/* End of product action */}
          <p className="text-tiny mb-2 mt-2">
              Showing 1 out of 31
              </p>
          {/* Product cards */}
          <div className="flex md:flex-wrap  flex-col md:flex-row justify-center lg:justify-start mt-4 md:mt-8">
          {
          products.map((prod) => {
           
            return (
              <ProductCard  key={prod.id} prod={prod} qty={findQty(prod.id)} />
            )
          })
        }
          
        
          </div>
          {/* End of Product Card */}
          {/* View All Product */}
          {/* <div className="flex justify-center mt-4">
          <Link to="/all-products" className="font-poppins font-medium  text-base mb-2 text-white bg-tradr-green px-8 lg:px-24 py-2  " >
            View All Products
            </Link>
            </div> */}
            <div className="flex justify-center mt-8">
            <Pagination />
            </div>

        </div>
        <Footer />
        </div>
  )
}

export default AllProducts